//This will be used by the business users to retrieve jobsites and toggle their status.

import axios from 'axios';

const getJobSites_API = '/api/dash/getJobSites';
const toggleJobsiteStatus_API = '/api/dash/toggleStatus';
const deleteJobsite_API = '/api/dash/deleteJobsite'; // This is not used in the current code but can be used for future reference
const assignForeman_API = '/api/dash/assignForeman'; 
const removeForeman_API = '/api/dash/removeForeman';
// Retrieve all jobsites
const getJobsites = async (token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await axios.get(getJobSites_API, config); // Use getJobSites_API
   
    return response.data; // Ensure this returns the correct data structure
};

// Toggle the status of a jobsite
const toggleJobsiteStatus = async (siteId, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await axios.put(`${toggleJobsiteStatus_API}/${siteId}`, {}, config); // Use toggleJobsiteStatus_API
    return response.data;
};



// Soft Delete a jobsite. 
const deleteJobsite = async (jobsiteID, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await axios.post(`${deleteJobsite_API}`, { jobsiteID }, config); // Use deleteJobsite_API
    return response.data;
};

// Assign a foreman to a jobsite
// API expects jobsiteId and workerId in the request body.
const assignForeman = async (foremanAssignData, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await axios.put(`${assignForeman_API}`, foremanAssignData, config);
    return response.data;
};


//Remove a foreman from a jobsite.
const removeForeman = async (removeForemanData, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await axios.put(`${removeForeman_API}`, removeForemanData, config);
    return response.data;
};

const jobsitesService = {
    getJobsites,
    toggleJobsiteStatus,
    deleteJobsite,
    assignForeman,
    removeForeman,
};

export default jobsitesService;




